import { render, staticRenderFns } from "./SharingMetric.vue?vue&type=template&id=54a44462&scoped=true&"
import script from "./SharingMetric.vue?vue&type=script&lang=ts&"
export * from "./SharingMetric.vue?vue&type=script&lang=ts&"
import style0 from "./SharingMetric.vue?vue&type=style&index=0&id=54a44462&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a44462",
  null
  
)

export default component.exports